import * as consts from 'consts/consts';
import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import {
  useDevelopmentPlanAdmin,
  useIsSuperAdminNonImpersonating,
} from 'utils/models/User';
import { useFeatures } from 'utils/util/features';
import Page from '../Layout/Pages/Page';
import { AdministrationTab } from './administrationTabs';
import { DevelopmentPlanTemplatesPage } from './ContentAdministration/TemplatesAdmin';
import { useCreateTemplateAction } from './ContentAdministration/TemplatesAdmin/useCreateTemplateAction';
import OrganizationAudit, {
  AuditEntryType,
} from './PeopleAdministration/Audit/OrganizationAudit';

const DevelopmentPlansAdministrationPage: FC = () => {
  const { formatMessage } = useIntl();
  const { isEnabled, isGroupAndOptionEnabled } = useFeatures();
  const { isDevelopmentPlanAdmin } = useDevelopmentPlanAdmin();
  const isSuperAdmin = useIsSuperAdminNonImpersonating();
  const { onCreateRef, action } = useCreateTemplateAction();

  const tabs: AdministrationTab[] = [];

  // the section only holds templates and their audit trail, so it follows
  // the templates flag
  if (
    isEnabled('development_plans') &&
    isGroupAndOptionEnabled('content_administration', 'templates_enabled') &&
    (isDevelopmentPlanAdmin || isSuperAdmin)
  ) {
    tabs.push({
      // first tab, so it also answers the section's base path
      path: consts.ADMINISTRATION_DEVELOPMENT_PLANS_TEMPLATES(formatMessage)
        .path,
      paths: [
        consts.ADMINISTRATION_DEVELOPMENT_PLANS(formatMessage).path,
        consts.ADMINISTRATION_DEVELOPMENT_PLANS_TEMPLATES(formatMessage).path,
      ],
      name: consts.ADMINISTRATION_DEVELOPMENT_PLANS_TEMPLATES(formatMessage)
        .name,
      content: <DevelopmentPlanTemplatesPage onCreateRef={onCreateRef} />,
      action,
    });

    tabs.push({
      path: consts.ADMINISTRATION_DEVELOPMENT_PLANS_AUDIT(formatMessage).path,
      name: consts.ADMINISTRATION_DEVELOPMENT_PLANS_AUDIT(formatMessage).name,
      content: (
        <OrganizationAudit
          auditEntryTypes={[AuditEntryType.DEVELOPMENT_PLAN_MANAGEMENT]}
        />
      ),
    });
  }

  return (
    <Page
      title={consts.ADMINISTRATION_DEVELOPMENT_PLANS(formatMessage).name}
      forceShowTabs={true}
      tabs={tabs}
    />
  );
};

export default React.memo(DevelopmentPlansAdministrationPage);
